import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';


const startTime = performance.now();


bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    const endTime = performance.now();
    const initializationTime = endTime - startTime;
    console.log(`Angular initialization time: ${initializationTime}ms`);
  })
  .catch((err) => console.error(err));


// platformBrowserDynamic().bootstrapModule(AppModule)
//   .then(() => {
//     const endTime = performance.now();
//     const initializationTime = endTime - startTime;
//     // Sentry.captureMessage(`Angular initialization time: ${initializationTime}ms`, Sentry.Severity.Info);
//   })
//   .catch(err => console.error(err));
